import React, { useState, useEffect } from 'react'
import WarningTriangle from '../../../public/assets/img/warning.svg';
import EmailIcon from '../../../public/assets/img/union.svg';
import CheckedIcon from '../../../public/assets/img/subtract.svg'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector, } from 'react-redux';
import { useBeforeunload } from 'react-beforeunload';
import { getClearResponse } from '../../redux/actions/checkmateAuthorizationAction';
import { userNameSelector } from '../../redux/saga/amazonWebServicesSelector';
import { ACC_CREATED_BACK_HOME, ACC_CREATED_BACKHOME_ADMIN, ACC_CREATED, ACC_CREATED_ADMIN, ACC_CREATED_BACK, CHANGE_PASSWORD_URL, CHECK_EMAIL, CHECK_EMAIL_DES, CONTINUE_TEXT, GO_BACK, IACM_TEXT, INTER_FAILED, INTER_FAILED_DES, INTER_SUCCESS, INTER_SUCCESS_DES, PASSWORD_OTP_FAILED, PASSWORD_UPDATED, PASSWORD_UPDATED_DESC, RESET_PASSWORD_FAILED, RESET_PASSWORD_FAILED_DESC, RESET_PASSWORD_UPDATED, RESET_PASSWORD_UPDATED_DESC, RETURN_TO_LOGIN, SIGNUP_TEXT, SUB_UNSUSS, SUB_UNSUSS_DES, SUB_UNSUSS_DES2, ACC_ADMIN_CREATED_DES, ADMIN_SIGNUP, GO_BACK_SUB } from '../../constants/merchantsConstants';
import { clearCreateAdminRequestResponse, createCreateAccountOTTERIACMResponse } from '../../redux/actions/accountServiceAction';
import {IconButtonComponent} from '../../../src/shared/iconbutton/iconButton';
import {getrejectonboardingbusinessInfoRequest} from '../../redux/actions/adminFlow/rejectbusinessInfoAction';
import {onboardingStatusSaga, businessIdSaga} from '../../redux/saga/adminFlow/businessInfoSelector';
import {rejectonboardingBusinessErrorSaga} from '../../redux/saga/adminFlow/rejectbusinessInfoSelector';
import {approveonboardingBusinessInfo, approveonboardingBusinessInfoErrorSaga} from'../../redux/saga/adminFlow/approvebusinessInfoSelector';
import { MERCHANT_APPROVED_HEADERTXT, MERCHANT_APPROVED_SUBHEADERTXT,MERCHANT_APPROVED_BTNTXT,MERCHANT_NOTAPPROVED_SUBHEADERTXT2, MERCHANT_CONFIRMED_HEADERTXT,MERCHANT_CONFIRMED_SUBHEADERTXT, MERCHANT_CONFIRMED_BTNTXT, MERCHANT_ONBOARDCOMPLETE_HEADERTXT,MERCHANT_NOTAPPROVED_HEADERTXT, MERCHANT_NOTAPPROVED_SUBHEADERTXT, MERCHANT_NOTAPPROVED_BTNTXT, MERCHANT_ONBOARDCOMPLETE_SUBHEADERTXT,MERCHANT_ONBOARDCOMPLETE_BTNTXT, MERCHANT_NOTCONFIRMED_HEADERTXT, MERCHANT_NOTCONFIRMED_SUBHEADERTXT, MERCHANT_NOTCONFIRMED_BTNTXT, USER_ADMIN_CREATED_1, WHATS_NEXT, USER_ADMIN_CREATED_2, USER_ADMIN_CREATED_3, USER_ADMIN_CREATED_4, USER_MERCHANT_CREATED_1, USER_MERCHANT_CREATED_2, USER_MERCHANT_CREATED_3, DONT_SEE_IT, RESEND_EMAIL } from '../../constants/Admin/adminConstants';
import {getapproveonboardingbusinessInfoRequest} from '../../redux/actions/adminFlow/approvebusinessInfoAction';


const CustomStatusPage = ({ statusIndicator, currentStep, onStepChange, pageData, bizId }) => {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [indicatorIcon, updateIndicatorIcon] = useState('');
  const [headerText, updateHeaderText] = useState('');
  const [subHeaderText, updateSubHeaderText] = useState('');
  const [subHeaderText2, updateSubHeaderText2] = useState('');
  const [buttonText, updateButtonText] = useState('');
  const [goBackLink, updategoBackLink] = useState('');
  const [bottomText, updateBottomText] = useState('');
  const [approveError, setApproveError] = useState(false);
  let userNameString = useSelector(userNameSelector);

  const[tempStep, setTempStep] = useState('');
  const approveFail =  useSelector(approveonboardingBusinessInfoErrorSaga);

  useEffect(() => {

    if (statusIndicator === 'Login_Success') {
      updateIndicatorIcon(CheckedIcon);
      updateHeaderText(INTER_SUCCESS);
      updateSubHeaderText(INTER_SUCCESS_DES);
      updateButtonText(GO_BACK);
      updategoBackLink(IACM_TEXT);
      dispatch(getClearResponse({}));
      updateBottomText(null);

    } else if (statusIndicator === 'Login_Failed') {
      updateIndicatorIcon(WarningTriangle);
      updateHeaderText(INTER_FAILED);
      updateSubHeaderText(INTER_FAILED_DES);
      updateButtonText(GO_BACK_SUB);
      updategoBackLink(IACM_TEXT);
      dispatch(getClearResponse({}));
      updateBottomText(null);
      
    } else if (statusIndicator === 'User_Created') {
      updateIndicatorIcon(CheckedIcon);
      updateHeaderText(ACC_CREATED);
      updateButtonText(ACC_CREATED_BACK);
      updategoBackLink(SIGNUP_TEXT);
      updateBottomText(null);
	  updategoBackLink(ACC_CREATED_BACK_HOME);
	  updateSubHeaderText(
	  	<>
			<div className='account-confirmation-details-merchant-title'>{USER_MERCHANT_CREATED_1}</div>
			<div className='account-confirmation-details-merchant'>{WHATS_NEXT}</div>
			<ol className='text-align-left'>
				<li>{USER_MERCHANT_CREATED_2}</li>
				<li>{USER_MERCHANT_CREATED_3}</li>
			</ol>
		</>
		);
    }
    else if (statusIndicator === 'User_Admin_Created') {
      updateIndicatorIcon(CheckedIcon);
      updateHeaderText(ACC_CREATED_ADMIN);
      //updateSubHeaderText(ACC_ADMIN_CREATED_DES);
      updateButtonText(ACC_CREATED_BACK);
      updategoBackLink(ACC_CREATED_BACK_HOME);
      updateBottomText(null);
	  updateSubHeaderText(
	  	<>
			<div className='account-confirmation-details-merchant-title'>{USER_ADMIN_CREATED_1}</div>
			<div className='account-confirmation-details-merchant'>{WHATS_NEXT}</div>
			<ul className='text-align-left'>
				<li>{USER_ADMIN_CREATED_2}</li>
				<li>{USER_ADMIN_CREATED_3}</li>
			</ul>
			<div className='account-confirmation-details-merchant'>{USER_ADMIN_CREATED_4}</div>
		</>
		);
    } 
	else if (statusIndicator === 'Merchant_Approved') {
		updateIndicatorIcon(CheckedIcon);
		updateHeaderText(MERCHANT_APPROVED_HEADERTXT );
		updateSubHeaderText(MERCHANT_APPROVED_SUBHEADERTXT);
		updateButtonText(MERCHANT_APPROVED_BTNTXT);
		updategoBackLink('dashboard/businessinfo');
		updateBottomText(null);
  
	}
	else if (statusIndicator === 'Merchant_Approve_Fail') {
		updateIndicatorIcon(WarningTriangle);
		updateHeaderText(MERCHANT_NOTAPPROVED_HEADERTXT);
		updateSubHeaderText(MERCHANT_NOTAPPROVED_SUBHEADERTXT);
		updateSubHeaderText2(MERCHANT_NOTAPPROVED_SUBHEADERTXT2);
		updateButtonText(MERCHANT_NOTAPPROVED_BTNTXT);
		updategoBackLink('');
		updateBottomText(null);
	}
	else if (statusIndicator === 'Merchant_Confirmed') {
		updateIndicatorIcon(CheckedIcon);
		updateHeaderText(MERCHANT_CONFIRMED_HEADERTXT);
		updateSubHeaderText(MERCHANT_CONFIRMED_SUBHEADERTXT);
		updateButtonText(MERCHANT_CONFIRMED_BTNTXT);
		updateBottomText(null);
  
	}
	else if (statusIndicator === 'Merchant_NotConfirmed') {
		updateIndicatorIcon(WarningTriangle);
		updateHeaderText(MERCHANT_NOTCONFIRMED_HEADERTXT);
		updateSubHeaderText(MERCHANT_NOTCONFIRMED_SUBHEADERTXT);
		updateButtonText(MERCHANT_NOTCONFIRMED_BTNTXT);
		updategoBackLink('');
		updateBottomText(null);
  
	}
	else if (statusIndicator === 'Onboarding_Complete') {
		updateIndicatorIcon(CheckedIcon);
		updateHeaderText(MERCHANT_ONBOARDCOMPLETE_HEADERTXT);
		updateSubHeaderText(MERCHANT_ONBOARDCOMPLETE_SUBHEADERTXT);
		updateButtonText(MERCHANT_ONBOARDCOMPLETE_BTNTXT);
		updategoBackLink('dashboard/onboardbusiness');
		updateBottomText(null);
  
	}
    else if (statusIndicator === 'User_Admin_Creation_Failed') {
      updateIndicatorIcon(WarningTriangle);
      updateHeaderText(SUB_UNSUSS);
      updateSubHeaderText(SUB_UNSUSS_DES);
      updateButtonText(GO_BACK);
      updategoBackLink(ADMIN_SIGNUP);
      updateBottomText(null);
		
    }
	else if (statusIndicator === 'User_Created_Admin_Servererror') {
		updateIndicatorIcon(WarningTriangle);
		updateHeaderText(SUB_UNSUSS);
		updateSubHeaderText(SUB_UNSUSS_DES);
		updateButtonText(GO_BACK);
		updategoBackLink(ACC_CREATED_BACK_HOME);
		updateBottomText(null);
  
	  }else if (statusIndicator === 'User_Created_Admin') {
		updateIndicatorIcon(CheckedIcon);
		updateHeaderText(ACC_CREATED_ADMIN);
		updateSubHeaderText(<>
				<span>{USER_ADMIN_CREATED_1}</span>
			<div className='account-confirmation-details'>{WHATS_NEXT}</div>
				<ul>
					<li>{USER_ADMIN_CREATED_2}</li>
					<li>{USER_ADMIN_CREATED_3}</li>
				</ul>
			</>);

		updateButtonText(ACC_CREATED_BACKHOME_ADMIN);
		updategoBackLink(ACC_CREATED_BACK_HOME);
		updateBottomText(null);
  
	  }else if (statusIndicator === 'User_Creation_Failed') {
      updateIndicatorIcon(WarningTriangle);
      updateHeaderText(SUB_UNSUSS);
      updateSubHeaderText(SUB_UNSUSS_DES);
      updateButtonText(GO_BACK);
      updategoBackLink(ACC_CREATED_BACK_HOME);
      updateBottomText(null);

    } else if (statusIndicator === 'Check_Email') {
      updateIndicatorIcon(EmailIcon);
      updateHeaderText(CHECK_EMAIL);
      updateSubHeaderText(CHECK_EMAIL_DES);
      updateButtonText(CONTINUE_TEXT);
      updategoBackLink(CHANGE_PASSWORD_URL);
      updateBottomText(<p className='resend-text'>{DONT_SEE_IT} <a className='resend-linktext' href='' onClick={resendEmailHandler}>{RESEND_EMAIL}</a></p>)

      if (!userNameString) {
        navigate('/')
      }

    } else if (statusIndicator === 'Password_Success') {
      updateIndicatorIcon(CheckedIcon);
      updateHeaderText(RESET_PASSWORD_UPDATED);
      updateSubHeaderText(RESET_PASSWORD_UPDATED_DESC);
      updateButtonText(RETURN_TO_LOGIN);
      updategoBackLink('');
      updateBottomText(null);
    } else if (statusIndicator === 'Password_Failed') {
      updateIndicatorIcon(CheckedIcon);
      updateHeaderText(RESET_PASSWORD_FAILED);
      updateSubHeaderText(RESET_PASSWORD_FAILED_DESC);
      updateButtonText(RETURN_TO_LOGIN);
      updategoBackLink('');
      updateBottomText(null);
    }
    else if (statusIndicator === 'Update_Password_Success') {
      updateIndicatorIcon(CheckedIcon);
      updateHeaderText(PASSWORD_UPDATED);
      updateSubHeaderText(PASSWORD_UPDATED_DESC);
      updateButtonText(RETURN_TO_LOGIN);
      updategoBackLink('');
      updateBottomText(null);
    } else if (statusIndicator === 'Update_Password_Failed') {
      updateIndicatorIcon(WarningTriangle);
      updateHeaderText(SUB_UNSUSS);
      updateSubHeaderText(SUB_UNSUSS_DES2);
      updateButtonText(RETURN_TO_LOGIN);
      updategoBackLink('');
      updateBottomText(null);
    }
    else if (statusIndicator === 'Update_Password_OTP_Failed') {
      updateIndicatorIcon(WarningTriangle);
      updateHeaderText(SUB_UNSUSS);
      updateSubHeaderText(PASSWORD_OTP_FAILED);
      updateButtonText(RETURN_TO_LOGIN);
      updategoBackLink('');
      updateBottomText(null);
    } else if(statusIndicator === 'GetStarted_success'){
		updateIndicatorIcon(CheckedIcon);
		updateHeaderText('Intake Form Submitted');
		updateSubHeaderText('The business intake form has been completed and an email will be sent to the email on file within 3-5 business days with next steps.');
		updateButtonText('Back to Login');
		updategoBackLink('');
		updateBottomText(null);
	  }
  }, [statusIndicator])

  const finaldata = useSelector(approveonboardingBusinessInfo);

  const currentBusinessInfo = useSelector(businessIdSaga);
  let businessId ='';
  let finalonbardingstatus ='';
  if (currentBusinessInfo){
	businessId = currentBusinessInfo.data;
  }

  const rejectFail =  useSelector(rejectonboardingBusinessErrorSaga);

  const goBackEvent = () => {
	if((statusIndicator === 'Merchant_Approve_Fail')){
		dispatch(getapproveonboardingbusinessInfoRequest(pageData, bizId));
			if(!approveFail) {
				if(approveFail?.error?.message) {
					setApproveError(true);
				}else{}
			}else {
				if(currentStep){
					currentStep++;
					onStepChange(currentStep);	
				}
			}
			
	}
	else if ((statusIndicator === 'Merchant_Confirmed' )){  // merchant  confirmed screen contract sign buttonclick
		const finalonbardingstatus = 'ONBOARD_COMPLETE';
		const statusupdatecall = {
			businessId,
			finalonbardingstatus
		}
		dispatch(getrejectonboardingbusinessInfoRequest(statusupdatecall));
		if(currentStep){
			currentStep++;
			onStepChange(currentStep);	
		}
	}
	else {
		dispatch(getClearResponse({}));
		dispatch(createCreateAccountOTTERIACMResponse());
		dispatch(clearCreateAdminRequestResponse());
		navigate('/' + goBackLink);
	}
}

  // merchant approved screen backfunctionality ------ START

		const handleClick = () => {
			if(currentStep){
				const finalonbardingstatus = 'NOT_ONBOARDED'
				const statusupdatecall = {
					businessId,
					finalonbardingstatus
				}
				dispatch(getrejectonboardingbusinessInfoRequest(statusupdatecall));
					if(rejectFail) {
						if(rejectFail.error.message) {
							// showpopup when back failed
							console.log('backclickFailed='+rejectFail.error.message);
						}else{}
					}else {
						currentStep--;
						onStepChange(currentStep);
					}
			}

			
		}

  //---------------------------------   END

  const resendEmailHandler = (e) => {
    e.preventDefault();
  }

  useBeforeunload(statusIndicator === 'Check_Email' ? (event) => event.preventDefault() : null);

  return (
	<>
        <Container className='container'>
       		<Row className='h-100 container--row'>
            	<Col className='container--row--col background-white-class'>
					<div className='container--row--col--logo'><img src={indicatorIcon} alt='Success header Logo' />
					<h5 className='container--row--col--logo--label'>{headerText}</h5></div>
					<div className='container--row--col--subtext'>{subHeaderText}</div>
					{statusIndicator === 'Merchant_Approve_Fail' && ( <div className='error-content'>
						<div className='container--row--col--subtext'>{subHeaderText2}</div>
						</div>
					)}
					<button className='container--alignright__button container--row--col--primaryButton' data-testid='goBackEvent' onClick={goBackEvent}>{buttonText}</button>
					<br></br>
					{statusIndicator === 'Merchant_Approved' && (
          				<IconButtonComponent buttonText={'Back'} clickEvent={handleClick} buttonvariant='light-button'/>
        			)}
					{(statusIndicator === 'Merchant_Approve_Fail' || statusIndicator === 'Merchant_NotConfirmed' ) && ( <div className='error-content'>
						<IconButtonComponent buttonText={'Back'} clickEvent={handleClick} buttonvariant='light-button' />
						</div>
					)}
					<br/>
					{bottomText}
				</Col>
            </Row>
        </Container>
	</>
  )}

export default CustomStatusPage;	